module.exports = __webpack_public_path__ + "img/Andin Widiana.00f50ae4.jpg";